import { get } from "lodash";
import basket from "@irati/checkout/utils/basket";
export default function getLimits(deal) {
    var limits = get(deal, "productConfig.limits.perRedemption", null);
    var openValueLimits = get(deal, "productConfig.limits.forOpenValue", null);
    return {
        minPrice: get(limits, "minPriceBeforeDiscounts", null),
        maxPrice: get(limits, "maxPriceBeforeDiscounts", null),
        minOpenValuePrice: get(openValueLimits, "minValue", null),
        maxOpenValuePrice: get(openValueLimits, "maxValue", null),
        numItems: get(limits, "numberOfItems", null),
        numProducts: get(limits, "numberOfProducts", null)
    };
}
export function hitLimits(deal) {
    var _a = getLimits(deal), maxPrice = _a.maxPrice, minPrice = _a.minPrice, numProducts = _a.numProducts, numItems = _a.numItems;
    var total = basket.breakdown.total;
    var items = basket.items;
    var reachedMinPrice = true;
    if (minPrice !== null) {
        reachedMinPrice = total.amount >= minPrice;
    }
    var reachedMaxPrice = false;
    if (minPrice !== null) {
        reachedMaxPrice = total.amount <= maxPrice;
    }
    var reachedMaxProducts = !!numProducts && items.length >= numProducts;
    var reachedMaxItems = !!numItems &&
        items.reduce(function (runningTotal, current) {
            return runningTotal + current.count;
        }, 0) >= numItems;
    return {
        reachedMinPrice: reachedMinPrice,
        reachedMaxPrice: reachedMaxPrice,
        reachedMaxProducts: reachedMaxProducts,
        reachedMaxItems: reachedMaxItems
    };
}
